import { Selector } from "react-redux";
import { RootState } from "..";
import { reportExtraAdapter } from "./reportExtraSlice";
import { ReportExtra } from "./types";

export const selectAllReportExtras: Selector<RootState, ReportExtra[]> = (
  state,
) => reportExtraAdapter.getSelectors().selectAll(state.reportExtra);
